import React from 'react';

import '../assets/css/CheckBoxFilter.scss';

import {getParams} from '../store/params/reducer';
import updateParams from '../store/params/action';
import {connect} from 'react-redux';

const CheckBoxFilter = ({
  data,
  dataArr,
  setDataArr,
  i,
  params,
  updateParams,
  type
}) => {

  const handleChecked = (e) => {
      let modified = [];
      let queryPm = [];
      let filters = {};

      if(data.order===0){
        modified = dataArr.map((medioP, index) => {
          if(index===0){
            medioP.selected = !medioP.selected;
          } else {
            medioP.selected = false;
          }
          if(medioP.id!=="all"){
            filters.[medioP.id] = medioP.selected;
          }
          return medioP;
        });
      } else {
        modified = dataArr.map((medioP, index) => {
          if(index===0 && medioP.order===0){
            medioP.selected = false;
          }
          if(index===i){
            medioP.selected = !medioP.selected;
          }
          if(medioP.selected){
            queryPm = [...queryPm, medioP.id];
          } else {
            queryPm = [...queryPm];
          }
          if(medioP.id!=="all"){
            filters.[medioP.id] = medioP.selected;
          }
          return medioP;
        });
      }

      setDataArr(modified);
      updateParams({
        ...params,
        limit: 18,
        from: 0,
        [type]: queryPm,
        filters: {
          ...params.filters,
          ...filters
        }
      });
  };

  return (
    <div className="ptb-10">
      <label className="container">{data.name}
        <input
          type="checkbox"
          checked={data.selected}
          onChange={handleChecked}/>
        <span className="checkmark"></span>
      </label>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    params: getParams(state)
  };
};

export default connect(mapStateToProps, {updateParams})(CheckBoxFilter);
